import { Routes } from "@angular/router";
import { RoleGuard } from "../../core/guards/role/role.guard";
import { UserRole } from "../../shared/enums/userRoles.enum";
import { ShippingMethodOrderComponent } from "./components/shipping-method-order/shipping-method-order.component";
import { ReportFooterTemplatesComponent } from "./components/report-footer-templates/report-footer-templates.component";
import { W9DocumentComponent } from "./components/w9-document/w9-document.component";

export const managementRoutes: Routes = [
  {
    canActivate: [RoleGuard],
    data: { roles: [UserRole.Admin] },
    path: "",
    component: ShippingMethodOrderComponent,
  },
  {
    canActivate: [RoleGuard],
    data: { roles: [UserRole.Admin] },
    path: "shipping-method-order",
    component: ShippingMethodOrderComponent,
  },
  {
    canActivate: [RoleGuard],
    data: { roles: [UserRole.Admin] },
    path: "w9-document",
    component: W9DocumentComponent,
  },
  {
    canActivate: [RoleGuard],
    data: { roles: [UserRole.Admin] },
    path: "report-footer-templates",
    component: ReportFooterTemplatesComponent,
  },
];
